import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';

// Services
import { AuthService } from './auth/auth.service';
import { NavMainService } from './services/nav-main/nav-main.service';
import { PermissionsService } from './services/permissions/permissions.service';
import { PublicCertificatesService } from './services/public-certificate/public-certificates.service';
import { PublicMultiCertificatesService } from './services/public-multi-certificate/public-multi-certificate.service';
import { UserProfileService } from './services/user-profile/user-profile.service';
import { ValuesService } from './services/values/values.service';

// Guards
import { AuthGuard } from './guards/auth/auth.guard';
import { RoleGuard } from './guards/role/role.guard';

// Interceptors
import { ApiUrlInterceptor } from './interceptors/api-url/api-url.interceptor';
import { AuthInterceptor } from './interceptors/auth/auth.interceptor';
import { Catch401Interceptor } from './interceptors/catch401/catch401.interceptor';
import { Catch403Interceptor } from './interceptors/catch403/catch403.interceptor';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    // Services
    AuthService,
    ValuesService,
    PermissionsService,
    NavMainService,
    UserProfileService,
    PublicCertificatesService,
    PublicMultiCertificatesService,
    // Guards
    AuthGuard,
    RoleGuard,
    // Interceptors
    { provide: HTTP_INTERCEPTORS, useClass: ApiUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Catch401Interceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Catch403Interceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
